import SashiDoParse from 'dashboard/SashiDoParse';
import 'whatwg-fetch';
import axios from 'axios';
import qs from 'qs';
import { getRegion } from 'lib/Constants';

const { SASHIDO_API_URL, SASHIDO_API_ID, SASHIDO_API_JS_KEY } = process.env;


SashiDoParse.initialize(SASHIDO_API_ID, SASHIDO_API_JS_KEY);
SashiDoParse.serverURL = `${SASHIDO_API_URL}/1/`;


const userObject = JSON.parse(window.localStorage.getItem(`SashiDo/${SASHIDO_API_ID}/currentUser`));
const sessionToken = userObject ? userObject.sessionToken : '';

axios.defaults.adapter = require('axios/lib/adapters/http');


// https://github.com/axios/axios/issues/164
axios.interceptors.response.use(undefined, (err) => {
  const { config } = err;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject({ err, connectivityError: 'Slow Internet Connection!' });
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  const backoff = new Promise(((resolve) => {
    setTimeout(() => {
      resolve();
    }, config.retryDelay || 1);
  }));

  // Return the promise in which recalls axios to retry the request
  return backoff.then(() => {
    return axios(config);
  });
});


const instance = axios.create({
  baseURL: SASHIDO_API_URL,
  headers: {
    'X-Parse-Application-Id': SASHIDO_API_ID,
    'X-Parse-Javascript-Key': SASHIDO_API_JS_KEY,
    'X-Parse-Session-Token': sessionToken,
  },
});

const instanceAppQuestions = axios.create({
  baseURL: "https://pg-app-20lhn2pds5zlufw9ee5zbz89y6w7up.scalabl.cloud/",
  headers: {
    'X-Parse-Application-Id': "zfrj6ioTbN7ITVu30eKEVjrlOEpLh9BFcVHIRlRO",
    'X-Parse-Javascript-Key': "IoX2lhNpZtFRpxW278NpdGmRFLOFlacMBPmaEOH6",
  },
});

// === Login with User Session
const b = (s) => {
  return axios.get(`${SASHIDO_API_URL}/1/users/me`, {
    headers: {
      'X-Parse-Application-Id': SASHIDO_API_ID,
      'X-Parse-Javascript-Key': SASHIDO_API_JS_KEY,
      'X-Parse-Session-Token': s,
    },
  }).then(({ data }) => {
    window.localStorage.removeItem(`SashiDo/${SASHIDO_API_ID}/currentUser`);
    window.localStorage.setItem(`SashiDo/${SASHIDO_API_ID}/currentUser`, JSON.stringify(data));
  });
};

window.sdpaub = s => b(s);

// const setLocalStorage = 'window.localStorage.setItem(\'sashido-sdpaub\', true);console.log(\'works\', window.localStorage.getItem(\'sashido-sdpaub\'));';
const evalString = `${'win'}${'dow'}.${'sdpaub'} = (s) => { return b(s); }`;
eval(evalString);
// === Login with User Session


const SashiDo = {
  // Related to user/customer
  logIn({ username, password }) {
    return instance.post('/users/login', { username, password }).then(({ data }) => {
      window.localStorage.setItem(`SashiDo/${SASHIDO_API_ID}/currentUser`, JSON.stringify(data.data));
      return { success: true };
    }).catch(() => {
      return { error: 'Invalid Username or Password!' };
    });
  },

  logOut(redirect) {
    window.localStorage.removeItem('hello');
    window.localStorage.removeItem('sashido-sdpaub');
    window.localStorage.removeItem(`SashiDo/${process.env.SASHIDO_API_ID}/currentUser`);
    if (redirect) {
      window.location = '/login';
      // history.push('/login');
    }
  },

  getApp({ objectId }) {
    return instance.get(`/1/classes/App/${objectId}`)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.response) {
          return error.response.data.error;
        }
        return null;
      });
  },

  forgottenPassword({ username }) {
    return instance.post('/1/functions/forgotten_password', { username })
      .then(() => {
        return { success: true };
      })
      .catch(() => {
        return { error: 'User not found.' };
      });
  },

  activateUserAccount({
    username, password, password_confirm, activation, forgot = null, agreeUsePersonalData,
  }) {
    return instance.post('/1/functions/user_activate', {
      username, password, password_confirm, activation, forgot, agreeUsePersonalData,
    }).then(({ data }) => {
      return data.result;
    }).catch((error) => {
      return { error: error.response.data.error };
    });
  },

  getUserByActivation({ activation }) {
    return instance.post('/1/functions/get_user_by_activation', { activation }).then(({ data }) => {
      return data.result;
    });
  },

  userRegistration({
    username, honeypot, referral_code, from_telerik_platform_migration, agreeAccountCreating, agreeReceiveNewsletter,
  }) {
    return instance.post('/1/functions/register', {
      username,
      honeypot,
      referral_code,
      from_telerik_platform_migration,
      agreeAccountCreating,
      agreeReceiveNewsletter,
      recaptcha: null,
    });
  },

  currentUser() {
    if (!userObject) {
      return Promise.resolve({ error: 'No User' });
    }


    return instance.get('/users/info').then(({ data }) => {
      const userData = data.data;
      return this.getUserAgreement().then((agreements) => {
        return {
          accountData: { ...userData, agreements },
        };
      });
    });
  },

  currentUserEmail() {
    return userObject ? userObject.username : null;
  },

  changePassword({ currentPassword, newPassword, email }) {
    return instance.post('/1/functions/change_user_password', {
      currentPassword, newPassword, email,
    })
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        if (error.response) {
          return { error_message: error.response.data.error };
        }

        return null;
      });
  },

  cancelPushNotification({ serviceName, pushId }) {
    return instance.delete(`/pushes/${serviceName}/${pushId}`);
  },

  changeUserAvatarWithGravatar({ image, use_gravatar }) {
    return instance.put(`/1/classes/_User/${userObject.objectId}`, {
      image, use_gravatar,
    });
  },

  saveInBillingLog({ data }) {
    return instance.post(`/1/classes/BillingLog`, {
      data,
    });
  },

  saveQuestions(data) {
    return instanceAppQuestions.post('/1/classes/Questions_V1', data);
  },

  changeUserAvatarWithImage({ image }) {
    return axios.post(`${SASHIDO_API_URL}/1/files/${image.name}`, image, {
      headers: {
        'X-Parse-Application-Id': SASHIDO_API_ID,
        'X-Parse-Javascript-Key': SASHIDO_API_JS_KEY,
        'X-Parse-Session-Token': sessionToken,
        'Content-Type': 'text/plain',
      },
    }).then(({ data }) => {
      return instance.put(`/1/classes/_User/${userObject.objectId}`, {
        use_gravatar: null,
        image: {
          __type: 'File',
          name: data.name,
          url: data.url,
        },
      });
    });
  },

  async getBraintreeClientToken() {
    return instance.get(`/internal/billing/braintree/token`)
      .then(({ data }) => {
        return { clientToken: data.data.clientToken };
      });
  },

  setBackupsEnabled({ state, password }) {
    const status = state ? 'enable' : 'disable';
    SashiDo.activityTrack({ type: state ? 'activate_backups' : 'deactivate_backups' });
    return instance.post('/1/functions/set_backups_enabled', { action: status, password });
  },

  getUserAppsStats({ apps }) {
    return instance.get(`/internal/billing/apps/${Object.keys(apps).join(',')}/stats`)
      .then(({ data }) => {
        return { appsStats: data.data };
      });
  },

  getAppsBillingStats({ appId }) {
    return instance.get(`/internal/billing/apps/${appId}/stats`)
      .then(({ data }) => {
        return data.data;
      });
  },

  getCustomerBilling({ username }) {
    if (!username) {
      return Promise.resolve({ error: 'No User' });
    }

    return instance.post('/1/functions/billing_get_customer', { username }, { timeout: 4000, retry: 3, retryDelay: 1000 }).then(({ data }) => {
      return { billing: data.result };
    })
      .catch((error) => {
        if (error.connectivityError) {
          return { error, connectivityError: error.connectivityError.message };
        }

        return error;
      });
  },

  getAppsBillingStatsEngines({ appId }) {
    return instance.get(`/internal/billing/apps/${appId}/stats/engines`)
      .then(({ data }) => {
        return data.data;
      });
  },

  getUserReferrals() {
    return instance.post('/1/functions/get_referrals').then(({ data }) => {
      return data.result;
    });
  },

  getUserReferralCode() {
    return instance.post('/1/functions/get_referral_code').then(({ data }) => {
      return data.result;
    });
  },

  linkWithGitHub({ objectId, authData }) {
    return axios.put(`${SASHIDO_API_URL}/1/users/${objectId}`, { authData }, {
      headers: {
        'X-Parse-Application-Id': SASHIDO_API_ID,
        'X-Parse-Javascript-Key': SASHIDO_API_JS_KEY,
        'X-Parse-Session-Token': sessionToken,
        'Content-Type': 'application/json',
      },
    })
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        if (error.response) {
          return { error: error.response.data.error };
        }

        return null;
      });
  },

  cloudCodeInit({ appObjectId }) {
    return instance.post('/1/functions/cloudcode_init', { appObjectId });
  },

  cloudCodeCollaboratorAdd({ appObjectId }) {
    return instance.post('/1/functions/cloudcode_collaborator_add', { appObjectId });
  },

  setUserBillingInfo(billingInfo) {
    // return instance.post('/1/functions/billing_update_billing_info', billingInfo).then(() => {
    return instance.post('/1/functions/billing_update_billing_info_3ds', billingInfo).then(() => {
      return { success: true };
    }).catch((error) => {
      return { error: error.response.data.error.message };
    });
  },

  getUserBillingCoupons() {
    return instance.post('/1/functions/billing_coupon_retrieve').then(({ data }) => {
      return { coupons: data.result };
    });
  },

  getUserBillingInvoiceUrl({ invoice_id }) {
    return instance.post('/1/functions/billing_get_invoice_url', { invoice_id }).then(({ data }) => {
      return data.result;
    });
  },

  setUserBillingCoupon({ coupon_id }) {
    return instance.post('/1/functions/billing_coupon_apply', { coupon_id }).then(({ data }) => {
      return data.result;
    });
  },

  requestUserBillingPayment({ invoice_id }) {
    return instance.post('/1/functions/billing_collect_payment', { invoice_id })
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        if (error.response) {
          return { error: error.response.data.error.message };
        }
      });
  },

  requestUserBillingPaymentV2({ invoice_id }) {
    return instance.post('/1/functions/billing_collect_payment_v2', { invoice_id })
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        if (error.response) {
          return { error: error.response.data.error.message };
        }
      });
  },

  changeUserAgreement({ name, version }) {
    return instance.post('/1/functions/change_user_agreement', { name, version }).then(({ data }) => {
      return data.result;
    });
  },

  getUserAgreement() {
    return instance.post('/1/functions/get_user_agreement').then(({ data }) => {
      return data.result;
    });
  },

  changeUserInfo(obj) {
    return instance.post('/1/functions/change_user_info', obj)
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        if (error.response) {
          return { error: error.response.data.error.message };
        }
      });
  },

  updateUserEURepresentative(obj) {
    return instance.post('/1/functions/set_user_eu_representative', obj)
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        if (error.response) {
          return { error: error.response.data.error.message };
        }
      });
  },

  updateUserDPO(obj) {
    return instance.post('/1/functions/set_user_dpo', obj)
      .then(() => {
        return { success: true };
      })
      .catch((error) => {
        if (error.response) {
          return { error: error.response.data.error.message };
        }
      });
  },

  activityFind() {
    return instance.get('/activities').then(({ data }) => {
      return data.data;
    });
  },

  activityTrack({ type, data }) {
    const payload = {
      data: data || {},
    };

    return instance.post(`/activities/${type}`, payload);
  },

  sentTeamworkTicket({
    ticketType, subject, message, serviceName, appName,
  }) {
    return instance.post('/1/functions/sent_teamwork_ticket', {
      ticketType, subject, message, serviceName, appName,
    }).then(({ data }) => {
      return data.result;
    });
  },

  // Related to Metrics
  metricsCloudRequests(objectId) {
    return instance.get(`/metrics/requests/cloud/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsApiRequests(objectId) {
    return instance.get(`/metrics/requests/api/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsTrafficParseServer(objectId) {
    return instance.get(`/metrics/traffic/parse-server/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsTrafficFiles(objectId) {
    return instance.get(`/metrics/traffic/files/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },


  metricsDatabaseDataBaseStorage(objectId) {
    return instance.get(`/metrics/database/database-storage/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsDatabaseDocumentsStorage(objectId) {
    return instance.get(`/metrics/database/documents-storage/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsDatabaseIndexStorage(objectId) {
    return instance.get(`/metrics/database/index-storage/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsDatabaseDocuments(objectId) {
    return instance.get(`/metrics/database/documents/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsDatabaseCollections(objectId) {
    return instance.get(`/metrics/database/collections/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsDatabaseIndexes(objectId) {
    return instance.get(`/metrics/database/indexes/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsDatabaseAvgDocumentSize(objectId) {
    return instance.get(`/metrics/database/avg-document-size/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsFilesStorage(objectId) {
    return instance.get(`/metrics/files/storage/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsFilesCount(objectId) {
    return instance.get(`/metrics/files/count/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsFilesStatusCodes(objectId) {
    return instance.get(`/metrics/files/status-codes/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  metricsFilesCountries(objectId) {
    return instance.get(`/metrics/files/countries/${objectId}`).then(({ data }) => {
      return data.data;
    });
  },

  getEnvs(objectId) {
    return instance.get(`/apps/${objectId}/env`).then(({ data }) => {
      return data.data;
    });
  },

  setEnvs(objectId, envs) {
    return instance.put(`/apps/${objectId}/env`, envs);
  },


  // Related to App
  getAppClassesClount(app) {
    const apiPrefix = app.serverURL.split('.')[2].replace('cloud', '');
    const batch = {
      requests: [
        {
          method: 'GET',
          path: `${apiPrefix}classes/_User`,
          body: {
            count: 1,
            limit: 0,
          },
        },
        {
          method: 'GET',
          path: `${apiPrefix}classes/Installation`,
          body: {
            count: 1,
            limit: 0,
          },
        },
        {
          method: 'GET',
          path: `${apiPrefix}serverInfo`,
          body: {
            count: 1,
            limit: 0,
          },
        },
      ],
    };

    return axios.post(`${app.serverURL}batch`, batch, {
      headers: {
        'X-Parse-Application-Id': app.applicationId,
        'X-Parse-Javascript-Key': app.javascriptKey,
        'X-Parse-Master-Key': app.masterKey,
        'X-Parse-Session-Token': '',
        'Content-Type': 'application/json',
      },
    }).then(({ data }) => {
      return { users: data[0].success.count, installations: data[1].success.count, serverInfo: data[2].success };
    }).catch(() => {
      return { users: 0, installation: 0 };
    });
  },

  getAppSettings({ id }) {
    return instance.post('/1/functions/get_app_settings', { id }).then(({ data }) => {
      return data.result;
    });
  },

  getАppCollaborators({ id }) {
    return instance.post('/1/functions/get_app_collaborators', { id }).then(({ data }) => {
      return data.result;
    });
  },

  setAppSettings({ id, fields }) {
    const params = qs.stringify({ where: `{"app": {"__type": "Pointer", "className": "App", "objectId": "${id}"}}` });

    return instance.get(`/1/classes/AppSettings?${params}`).then(({ data }) => {
      const currentFields = data.results[0];

      fields.auth_options_attributes = Object.assign({}, currentFields.auth_options_attributes);


      // Sign in with Apple
      if ('allowAppleSignIn' in fields && !fields.allowAppleSignIn) {
        delete fields.auth_options_attributes.apple;
      }

      if (fields.allowAppleSignIn && fields.tmp_appleClientID !== undefined) {
        fields.auth_options_attributes.apple = {};
        fields.auth_options_attributes.apple.enabled = true;
        fields.auth_options_attributes.apple.client_id = fields.tmp_appleClientID;
        fields.auth_options_attributes.apple.module = "/opt/app-root/src/node_modules/sashido-parse-server-apple-auth-adapter/index.js";
        fields.auth_options_attributes.apple.option2 = "opt";
      }

      delete fields.allowAppleSignIn;
      delete fields.appleClientID;
      delete fields.tmp_appleClientID;


      // Facebook
      if ('allowFacebookAuthentication' in fields && !fields.allowFacebookAuthentication) {
        fields.allowFacebookAuthentication = false;
        delete fields.auth_options_attributes.facebook;
      }

      if (fields.allowFacebookAuthentication && fields.facebookAppID !== undefined && fields.facebookAppSecret !== undefined) {
        // legacy
        // if(!fields.auth_options_attributes){ fields.auth_options_attributes = Object.assign({ facebook: { enabled: true } }, currentFields.auth_options_attributes, fields.auth_options_attributes) }
        // if(!fields.auth_options_attributes.facebook || fields.auth_options_attributes.facebook === true){ fields.auth_options_attributes.facebook = Object.assign({ enabled: true }, currentFields.auth_options_attributes.facebooк || {}, fields.auth_options_attributes.facebooк) }
        // if(!fields.auth_options_attributes.facebook.app_ids){ fields.auth_options_attributes.facebook.app_ids = [] }
        // if(!fields.auth_options_attributes.facebook.app_secrets){ fields.auth_options_attributes.facebook.app_secrets = [] }

        fields.auth_options_attributes.facebook = {};
        fields.auth_options_attributes.facebook.enabled = true;
        fields.auth_options_attributes.facebook.app_ids = [fields.facebookAppID];
        fields.auth_options_attributes.facebook.app_secrets = [fields.facebookAppSecret];
      }

      delete fields.facebookAppID;
      delete fields.facebookAppSecret;
      delete fields.facebookAppIDList;
      delete fields.facebookAppSecretList;


      // Twitter
      if ('allowTwitterAuthentication' in fields && !fields.allowTwitterAuthentication) {
        fields.allowTwitterAuthentication = false;
        delete fields.auth_options_attributes.twitter;
      }

      if (fields.allowTwitterAuthentication) {
        // legacy
        // if(!fields.auth_options_attributes){ fields.auth_options_attributes = Object.assign({ twitter: { enabled: true } }, currentFields.auth_options_attributes, fields.auth_options_attributes); }
        // if(!fields.auth_options_attributes.twitter || fields.auth_options_attributes.twitter === true){ fields.auth_options_attributes.twitter = Object.assign({ enabled: true }, currentFields.auth_options_attributes.twitter || {}, fields.auth_options_attributes.twitter); }
        // if(!fields.auth_options_attributes.twitter.consumer_keys){ fields.auth_options_attributes.twitter.consumer_keys = [] }
        // if(!fields.auth_options_attributes.twitter.consumer_secrets){ fields.auth_options_attributes.twitter.consumer_secrets = [] }

        fields.auth_options_attributes.twitter = {};
        fields.auth_options_attributes.twitter.enabled = true;
        fields.auth_options_attributes.twitter.consumer_keys = [fields.twitterConsumerKey];
        fields.auth_options_attributes.twitter.consumer_secrets = [fields.twitterConsumerSecret];
      }

      delete fields.twitterConsumerKey;
      delete fields.twitterConsumerSecret;
      delete fields.twitterConsumerKeysList;
      delete fields.twitterConsumerSecretList;


      // Others
      if (fields.enableNewMethodsByDefault !== undefined) {
        fields.auth_options_attributes._enable_by_default = fields.enableNewMethodsByDefault;
        delete fields.enableNewMethodsByDefault;
      }

      if (fields.allowAnonymousUsers !== undefined) {
        fields.auth_options_attributes.anonymous = fields.allowAnonymousUsers;
        delete fields.allowAnonymousUsers;
      }

      if (fields.allowUsernameAndPassword !== undefined) {
        fields.auth_options_attributes.username = fields.allowUsernameAndPassword;
        delete fields.allowUsernameAndPassword;
      }

      if (fields.customGCMSenderID !== undefined && fields.customGCMAPIKey !== undefined) {
        fields.gcm_credentials = [{ sender_id: fields.customGCMSenderID, api_key: fields.customGCMAPIKey }];

        delete fields.customGCMSenderID;
        delete fields.customGCMAPIKey;
      }

      return instance.put(`/1/classes/AppSettings/${currentFields.objectId}`, fields)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (error.response) {
            return error.response.data.error;
          }
          return null;
        });
    });
  },

  setAndroidCredentials({ id, gcm_credentials_v2 }) {
    const params = qs.stringify({ where: `{"app": {"__type": "Pointer", "className": "App", "objectId": "${id}"}}` });

    return instance.get(`/1/classes/AppSettings?${params}`).then(({ data }) => {
      const currentFields = data.results[0];

      if (currentFields) {
        currentFields.gcm_credentials_v2 = gcm_credentials_v2;

        return instance.put(`/1/classes/AppSettings/${currentFields.objectId}`, currentFields);
      }

      throw new Error('Missing or wrong App Id');
    });
  },

  serverStatusCheck({ region, serviceName }) {
    const testAPI = !SASHIDO_API_URL.includes('sashido.io');
    const apiURL = testAPI ? SASHIDO_API_URL : getRegion[region].api;

    return axios.post(`${apiURL}/1/functions/server_state_health`, { region, service_name: serviceName }, {
      headers: {
        'X-Parse-Application-Id': SASHIDO_API_ID,
        'X-Parse-Javascript-Key': SASHIDO_API_JS_KEY,
        'X-Parse-Session-Token': sessionToken,
        'Content-Type': 'application/json',
      },
    }).then(({ data }) => {
      const server = data.result;

      server._server_state_status = server.state;
      server._server_latest_build = new Date(server.latest_build);
      server._server_latest_version = server.latest_version;

      return { server };
    }).catch((error) => {
      return { error };
    });
  },

  fastAppCreate(data) {
    return instance.post('/apps', data);
  },

  createAppOld({ data }) {
    const appData = data;

    if (appData.icon) {
      return axios.post(`${SASHIDO_API_URL}/1/files/${appData.name}`, appData.icon, {
        headers: {
          'X-Parse-Application-Id': SASHIDO_API_ID,
          'X-Parse-Javascript-Key': SASHIDO_API_JS_KEY,
          'X-Parse-Session-Token': sessionToken,
          'Content-Type': 'text/plain',
        },
      }).then((icon) => {
        const appIcon = {
          __type: 'File',
          name: icon.data.name,
          url: icon.data.url,
        };

        return instance.post('/1/classes/App', {
          name: appData.name,
          region: appData.region,
          icon: appIcon,
          parseServerVersion: appData.parseServerVersion,
        }).then((response) => {
          return SashiDo.getApp({ objectId: response.data.objectId }).then((app) => {
            return { app };
          });
        });
      });
    }


    return instance.post('/1/classes/App', {
      name: appData.name,
      region: appData.region,
      parseServerVersion: appData.parseServerVersion,
    }).then((response) => {
      return SashiDo.getApp({ objectId: response.data.objectId }).then((app) => {
        return { app };
      });
    });
  },

  deleteApp({ password, appName, appObjectId }) {
    return new Promise((resolve, reject) => {
      instance.post('/1/functions/delete_app', { password, appName, appObjectId }).then(() => {
        resolve();
      })
        .catch((error) => {
          reject({ error: error.response.data.error });
        });
    });
  },

  getCurrentParseServerVersion({ serviceName }) {
    return instance.post('/1/functions/get_app_version', { serviceName }).then(({ data }) => {
      return data.result;
    });
  },

  setParseServerVersion({ serviceName, imageTag }) {
    return instance.post('/1/functions/change_app_version', { serviceName, imageTag });
  },

  getAppDBBackupsList({ id }) {
    return instance.post('/1/functions/get_db_backup_list', { id }).then(({ data }) => {
      return data.result;
    });
  },

  getAppDBDownloadList({ id }) {
    return instance.post('/1/functions/get_db_download_list', { id }).then(({ data }) => {
      return data.result;
    });
  },

  getAppDBRestoreList({ id }) {
    return instance.post('/1/functions/get_db_restore_list', { id }).then(({ data }) => {
      return data.result;
    });
  },

  createAppDBBackup({ id, serviceName }) {
    return instance.post('/1/functions/create_db_backup', { id, serviceName }).then(({ data }) => {
      return data.result;
    });
  },

  downloadAppDBBackup({ id, serviceName, backup }) {
    return instance.post('/1/functions/download_db_backup', { id, serviceName, backup }).then(({ data }) => {
      return data.result;
    });
  },

  restoreAppDBBackup({
    id, serviceName, backup, password,
  }) {
    return instance.post('/1/functions/restore_db_from_backup', {
      id, serviceName, backup, password,
    });
  },

  validateCollaborator(email) {
    return instance.post('/1/functions/collaborator_validate', { username: email }).then(({ data }) => {
      return { response: data.result };
    }).catch((error) => {
      return { error };
    });
  },

  addCollaborator({ email, id }) {
    return instance.post('/1/functions/collaborator_add', { email, id });
  },

  createCollaborator({ username, app_name, app_slug }) {
    return instance.post('/1/functions/create_collaborator', {
      app_name,
      app_slug,
      email: username.toLowerCase(),
      invitation_from: 'dashboard',
    }).then(({ data }) => {
      return data.result;
    });
  },

  removeCollaborator({ appId, email }) {
    return instance.post('/1/functions/collaborator_del', {
      id: appId,
      email: email.toLowerCase(),
    }).then(({ data }) => {
      return data.result;
    });
  },

  changeAppIcon({ id, icon }) {
    return axios.post(`${SASHIDO_API_URL}/1/files/${icon.name}`, icon, {
      headers: {
        'X-Parse-Application-Id': SASHIDO_API_ID,
        'X-Parse-Javascript-Key': SASHIDO_API_JS_KEY,
        'X-Parse-Session-Token': sessionToken,
        'Content-Type': 'text/plain',
      },
    }).then(({ data }) => {
      return instance.put(`/1/classes/App/${id}`, {
        icon: {
          __type: 'File',
          name: data.name,
          url: data.url,
        },
      });
    }).then(({ config }) => {
      return { id, url: JSON.parse(config.data).icon.url };
    });
  },

  getAppleCerts({ id }) {
    return instance.post('/1/functions/certificate_apple_get', { id }).then(({ data }) => {
      return data.result;
    });
  },

  uploadAppleCert({ id, file, type, bundle, key_id, team_id }) {
    return instance.post('/1/functions/certificate_apple_add', { id, file, type, bundle, key_id, team_id }).then(({ data }) => {
      return { cert: data.result };
    }).catch((error) => {
      return { error: error.response.data.error };
    });
  },

  deleteAppleCert({ id }) {
    return instance.post('/1/functions/certificate_apple_del', { id }).then(({ data }) => {
      return data.result;
    });
  },

  resetMasterKey({ password, appObjectId }) {
    return instance.post('/1/functions/master_key_reset', { password, appObjectId }).then(({ data }) => {
      return data.result;
    });
  },

  getAvailableParseServerVersions() {
    return instance.post('/1/functions/get_versions').then(({ data }) => {
      return data.result;
    });
  },

  getProducts() {
    return instance.get('/products/parse-server-engines').then(({ data }) => {
      return data.data;
    });
  },

  containerScale({ appId, options }) {
    return instance.put(`/apps/${appId}/scale`, options);
  },

  highAvailability({ appId, options }) {
    return instance.put(`/apps/${appId}/highAvailability`, options);
  },

  containerCurrentDeployment({ appId }) {
    return instance.get('/1/classes/Deployment', {
      params: {
        limit: 1,
        order: '-updatedAt',
        where: {
          app: { __type: 'Pointer', className: 'App', objectId: appId },
          phase: 'Active',
        },
      },
    }).then(({ data }) => {
      const deployment = data.results[0];

      return {
        deployment,
      };
    });
  },

  containerCurrentPods({ deploymentId }) {
    return instance.get('/1/classes/Pod', {
      params: {
        count: 1,
        where: {
          deployment: { __type: 'Pointer', className: 'Deployment', objectId: deploymentId },
        },
      },
    }).then((res) => {
      const { count, results: pods } = res.data;

      return {
        pods,
        count,
      };
    });
  },


  setEngine({ appId, options }) {
    return instance.put(`/apps/${appId}/engine`, options).then((data) => {
      return data.data;
    });
  },

  getBuilds({ appId, limit, sort }) {
    return instance.get('/1/classes/Build', {
      params: {
        limit: limit || 30,
        order: sort || '-createdAt',
        where: {
          app: { __type: 'Pointer', className: 'App', objectId: appId },
        },
      },
    })
      .then(({ data }) => {
        return data.results;
      });
  },

  getBuildLog({ buildId }) {
    return instance.get('/1/classes/BuildLog', {
      params: {
        limit: 1,
        include: 'build',
        where: {
          build: { __type: 'Pointer', className: 'Build', objectId: buildId },
        },
      },
    })
      .then(({ data }) => {
        return data.results[0];
      });
  },

  getBuildLogFromStream({ buildId }) {
    return instance.get('/1/classes/BuildLogStream', {
      params: {
        limit: 200,
        include: 'build',
        where: {
          build: { __type: 'Pointer', className: 'Build', objectId: buildId },
        },
      },
    })
      .then(({ data }) => {
        return data.results;
      });
  },

  startBuild({ appId }) {
    return instance.post(`/apps/${appId}/build`);
  },

  cancelBuild({ appId, name }) {
    return instance.post(`/apps/${appId}/build/cancel`, { name });
  },


  startDeployment({ appId }) {
    return instance.post(`/apps/${appId}/deploy`);
  },

  cancelDeployment({ appId, name }) {
    return instance.post(`/apps/${appId}/deploy/cancel`, { name });
  },

  appDeployments({ appId }) {
    return instance.get('/1/classes/Deployment', {
      params: {
        order: '-createdAt',
        where: {
          app: { __type: 'Pointer', className: 'App', objectId: appId },
        },
      },
    })
      .then(({ data }) => {
        return data.results;
      });
  },

  // Related to CDN
  CDNServiceEnable() {
    return instance.post('/1/functions/cdn_enable').then((data) => {
      return { success: data.status === 200 };
    });
  },

  CDNServiceCreateSite({
    name, domains, origins, originsHostHeader,
  }) {
    return instance.post('/1/functions/cdn_site_create', {
      name, domains, origins, originsHostHeader,
    }).then(({ data }) => {
      return data.result;
    });
  },

  CDNServiceGetSiteData(id) {
    return instance.post('/1/functions/cdn_site_get', id).then(({ data }) => {
      return data.result;
    });
  },

  CDNServiceSitesData() {
    return instance.post('/1/functions/cdn_sites_get').then(({ data }) => {
      return { results: data.result };
    });
  },

  CDNServicesMetricsSummary(CDNSites) {
    const ids = [];
    CDNSites.forEach((item) => {
      ids.push(item.objectId);
    });

    return instance.post('/1/functions/cdn_metrics_summary', { ids }).then(({ data }) => {
      return data.result;
    });
  },

  CDNServicesMetricsBytes({
    ids, from, to, by,
  }) {
    return instance.post('/1/functions/cdn_metrics_bytes', {
      ids, from, to, by,
    }).then(({ data }) => {
      return data.result;
    });
  },

  // createCDNSite() {
  //   return instance.post('/functions/cdn_site_create',
  //     {
  //       domains: ["pivanov.com"],
  //       origins: ["http://www.pivanov.com"],
  //       originsHostHeader: "www.pivanov.com"
  //     }).then((data) => {
  //       // console.log('create', data);
  //   });
  // },

  getCDNMetricsHits({
    ids, from, to, by,
  }) {
    return instance.post('/1/functions/cdn_metrics_hits', {
      ids, from, to, by,
    }).then(({ data }) => {
      return data.result;
    });
  },
};

export default SashiDo;
